import { Container, ThemeProvider, createTheme } from "@mui/material";
import ProductsLists from "components/dataList/ProductsLists";
import SearchSection from "components/dataList/SearchSection";
import { useState } from "react";

const theme = createTheme();

function Products() {
  const [filterSearch, setFilterSearch] = useState("");
  const [machineSearch, setMachineSearch] = useState("");
  const [typeSearch, setTypeSearch] = useState("");

  return (
    <ThemeProvider theme={theme}>
      <Container
        fixed
        maxWidth="lg"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: { xs: 1, sm: 2, md: 3 },
          paddingBottom: { xs: 1, sm: 2, md: 3 },
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <SearchSection
          setFilterSearch={setFilterSearch}
          setMachineSearch={setMachineSearch}
          setTypeSearch={setTypeSearch}
        />
      </Container>
      <Container>
        <ProductsLists
          filterSearch={filterSearch}
          machineSearch={machineSearch}
          typeSearch={typeSearch}
        />
      </Container>
    </ThemeProvider>
  );
}

export default Products;
